import noWorkoutsImage from '../../asset/image/no-workouts.png'
import React from 'react'
import { Button } from 'src/component/ui/button'

/**
 * Results empty state (GH-754): a full-width banner with a "See All Workouts" CTA shown when an
 * active filter returns zero workouts. No cards, no pagination. The CTA clears filters + sort,
 * which returns the page to the sections view.
 */
export const ResultsEmptyState = ({ onSeeAll }: { onSeeAll: () => void }): React.ReactElement => {
  return (
    <div
      className="relative flex w-full items-center justify-center overflow-hidden rounded-md aspect-[16/6]"
      style={{ backgroundImage: `url(${noWorkoutsImage})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
    >
      <div className="absolute inset-0 bg-black/40" />
      <Button
        variant="outline"
        onClick={onSeeAll}
        className="relative z-10 !border-ivory text-ivory hover:bg-ivory hover:text-black"
      >
        See All Workouts
      </Button>
    </div>
  )
}
